import { Waves, Facebook, Instagram, Linkedin, Youtube, Phone, Mail, MapPin } from "lucide-react";
import fairHousingLogo from "@assets/Equal-Housing-Opportunity-Logo_1756138134113.png";

export default function Footer() {
  const propertyLocations = [
    "Miami Beach",
    "Key Biscayne", 
    "Fort Lauderdale",
    "Boca Raton",
    "Naples"
  ];

  return (
    <footer className="bg-deep-navy text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center text-2xl font-playfair font-bold mb-4">
              <Waves className="w-8 h-8 mr-2" />
              South FL<span className="text-luxury-gold">Waterfront</span>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              South Florida's premier destination for luxury waterfront properties. 
              Connecting buyers with their dream oceanfront homes.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-luxury-gold transition-colors duration-200">
                <Facebook className="w-6 h-6" />
              </a>
              <a href="#" className="text-gray-300 hover:text-luxury-gold transition-colors duration-200">
                <Instagram className="w-6 h-6" />
              </a>
              <a href="#" className="text-gray-300 hover:text-luxury-gold transition-colors duration-200">
                <Linkedin className="w-6 h-6" />
              </a>
              <a href="#" className="text-gray-300 hover:text-luxury-gold transition-colors duration-200">
                <Youtube className="w-6 h-6" />
              </a>
            </div>
          </div>
          
          {/* Properties */}
          <div>
            <h4 className="font-semibold text-white mb-4">Properties</h4>
            <ul className="space-y-2 text-gray-300">
              {propertyLocations.map((location) => (
                <li key={location}>
                  <a href="#" className="hover:text-luxury-gold transition-colors duration-200">
                    {location}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Contact */}
          <div>
            <h4 className="font-semibold text-white mb-4">Contact</h4>
            <ul className="space-y-2 text-gray-300">
              <li className="flex items-center">
                <Phone className="w-4 h-4 mr-2 text-luxury-gold flex-shrink-0" />
                <span>(305) 555-0123</span>
              </li>
              <li className="flex items-center">
                <Mail className="w-4 h-4 mr-2 text-luxury-gold flex-shrink-0" />
                <span className="break-all">info@sellingsouthflwaterfront.com</span>
              </li>
              <li className="flex items-center">
                <MapPin className="w-4 h-4 mr-2 text-luxury-gold flex-shrink-0" />
                <span>Miami Beach, FL 33139</span>
              </li>
              <li className="mt-4">
                <a href="/admin" className="text-gray-400 hover:text-luxury-gold transition-colors duration-200 text-sm">
                  Agent Login
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Legal Disclaimer */}
        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="bg-gray-800 rounded-lg p-6 mb-8">
            <h4 className="font-semibold text-white mb-4 text-center">Legal Disclaimer</h4>
            <p className="text-gray-300 text-sm leading-relaxed text-center max-w-4xl mx-auto">
              <strong>Disclaimer:</strong> This website displays sample property data for demonstration purposes. In production, it integrates seamlessly with your IDX feed to display live MLS listings. We are an independent marketing platform and are not affiliated with any real estate brokerage or MLS. 
              All property listings, including photos and descriptions, are sourced from publicly available data and are provided for informational purposes only. 
              Information is deemed reliable but not guaranteed and should be verified with the listing broker. Equal Housing Opportunity.
            </p>
            <div className="flex items-center justify-center mt-4 space-x-6">
              <div className="flex items-center text-gray-400 text-xs">
                <img 
                  src={fairHousingLogo} 
                  alt="Equal Housing Opportunity" 
                  className="w-12 h-auto mr-3"
                />
                Equal Housing Opportunity
              </div>
            </div>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-300 text-sm">
              © 2024 SellingSouthFLWaterfront.com. All rights reserved.
            </div>
            <div className="flex space-x-6 text-sm text-gray-300 mt-4 md:mt-0">
              <a href="/about" className="hover:text-luxury-gold transition-colors duration-200">
                About
              </a>
              <a href="/privacy-policy" className="hover:text-luxury-gold transition-colors duration-200">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-luxury-gold transition-colors duration-200">
                Terms of Use
              </a>
              <a href="#" className="hover:text-luxury-gold transition-colors duration-200">
                Fair Housing
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
